import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/i18n'
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import AppThemeProvider from './components/AppThemeProvider'
import ErrorBoundary from './errors/ErrorBoundary'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppThemeProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AppThemeProvider>
  </Provider>
);

